export default "__VITE_ASSET__BeF3E8t$__"